module.exports = __webpack_public_path__ + "static/img/about1.36f88b74.png";